import { NgModule } from '@angular/core';
import { ExerciseComponent } from './exercise.component';
import { StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

@NgModule({
  declarations: [ExerciseComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule
  ],
  providers: [StreamingMedia],
  exports: [ExerciseComponent]
})
export class ExerciseModule { }
